<template>
  <v-container fluid ma-0 pa-0 px-4>
    <PageHeader
      title="Service Levels"
      subtitle="Create, update or delete Service Level Agreements."
    ></PageHeader>
    <v-flex xs12 pt-4>
      <v-flex xs12 v-for="(sla, index) in slas" :key="index">
        <ServiceLevel
          :slaIndex="index"
          :sla="sla"
          v-on:sla-update="updateSla"
          v-on:sla-delete="openDelete"
        >
        </ServiceLevel>
      </v-flex>
      <v-btn
        v-show="addServiceLevelButton"
        v-on:click="
          addServiceLevelForm = true;
          addServiceLevelButton = false;
        "
        class="ml-0 mt-0"
        color="secondary"
      >
        Add a Service Level
      </v-btn>
      <form v-show="addServiceLevelForm">
        <v-layout wrap row class="pa-4 white-bg elevation-2 rounded-3">
          <v-flex xs12 sm6>
            <v-text-field
              v-model="newSlaName"
              label="New Service Level name"
              box
            ></v-text-field>
            <v-select
              v-model="newSlaBucket"
              :items="buckets"
              item-text="name"
              item-value="id"
              box
              label="Select a bucket"
              dense
              append-icon="keyboard_arrow_down"
            >
            </v-select>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap fluid>
              <v-flex xs12 md6>
                <h4 class="pb-1">In jeopardy after...</h4>
                <v-select
                  v-model="newSlaJeopardyDays"
                  :items="dayOptions"
                  box
                  label="Days"
                  dense
                  append-icon="keyboard_arrow_down"
                  style="
                    width: calc(33.33% - 8px);
                    display: inline-block;
                    margin-right: 12px;
                  "
                >
                </v-select>
                <v-select
                  v-model="newSlaJeopardyHours"
                  :items="hourOptions"
                  box
                  label="Hrs"
                  dense
                  append-icon="keyboard_arrow_down"
                  style="
                    width: calc(33.33% - 8px);
                    display: inline-block;
                    margin-right: 12px;
                  "
                >
                </v-select>
                <v-select
                  v-model="newSlaJeopardyMinutes"
                  :items="minuteOptions"
                  box
                  label="Mins"
                  dense
                  append-icon="keyboard_arrow_down"
                  style="width: calc(33.33% - 8px); display: inline-block"
                >
                </v-select>
              </v-flex>
              <v-flex
                xs12
                sm6
                :class="{
                  'pl-0': $vuetify.breakpoint.mdAndDown,
                  'pl-2': $vuetify.breakpoint.mdAndUp,
                }"
              >
                <h4 class="pb-1 pl-1">Then run this task...</h4>
                <v-select
                  v-model="newSlaJeopardyTask"
                  :items="tasks"
                  item-text="description"
                  item-value="id"
                  box
                  label="Select a task"
                  dense
                  append-icon="keyboard_arrow_down"
                  :class="{
                    'pl-0': $vuetify.breakpoint.mdAndDown,
                    'pl-1': $vuetify.breakpoint.mdAndUp,
                  }"
                >
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap fluid>
              <v-flex xs12 md6>
                <h4 class="pb-1">In breach after...</h4>
                <v-select
                  v-model="newSlaBreachDays"
                  :items="dayOptions"
                  box
                  label="Days"
                  dense
                  append-icon="keyboard_arrow_down"
                  style="
                    width: calc(33.33% - 8px);
                    display: inline-block;
                    margin-right: 12px;
                  "
                >
                </v-select>
                <v-select
                  v-model="newSlaBreachHours"
                  :items="hourOptions"
                  box
                  label="Hrs"
                  dense
                  append-icon="keyboard_arrow_down"
                  style="
                    width: calc(33.33% - 8px);
                    display: inline-block;
                    margin-right: 12px;
                  "
                >
                </v-select>
                <v-select
                  v-model="newSlaBreachMinutes"
                  :items="minuteOptions"
                  box
                  label="Mins"
                  dense
                  append-icon="keyboard_arrow_down"
                  style="width: calc(33.33% - 8px); display: inline-block"
                >
                </v-select>
              </v-flex>
              <v-flex
                xs12
                md6
                :class="{
                  'pl-0': $vuetify.breakpoint.smAndDown,
                  'pl-2': $vuetify.breakpoint.mdAndUp,
                }"
              >
                <h4
                  :class="{
                    'pl-0 pb-1': $vuetify.breakpoint.smAndDown,
                    'pl-1 pb-1': $vuetify.breakpoint.mdAndUp,
                  }"
                >
                  Then run this task...
                </h4>
                <v-select
                  v-model="newSlaBreachTask"
                  :items="tasks"
                  item-text="description"
                  item-value="id"
                  box
                  label="Select a task"
                  dense
                  append-icon="keyboard_arrow_down"
                  :class="{
                    'pl-0': $vuetify.breakpoint.smAndDown,
                    'pl-1': $vuetify.breakpoint.mdAndUp,
                  }"
                >
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-switch
            color="secondary"
            label="Turn on this service level"
            v-model="newSlaEnabled"
            class="mb-0 mt-0"
          >
          </v-switch>
          <v-flex xs12>
            <v-btn class="ml-0" color="success" @click="createSla"
              >Confirm Service Level</v-btn
            >
            <v-btn color="error" v-on:click="clearCreate">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </form>
    </v-flex>
    <v-dialog v-model="showDeleteDialog" width="500">
      <v-card class="pa-4">
        <v-card-title class="ma-0 mb-2 pa-0">
          <h2>Delete Service Level Criteria</h2>
        </v-card-title>
        <v-card-text class="ma-0 mt-2 mb-1 pa-0">
          <p>Are you sure you want to delete this service level criteria?</p>
        </v-card-text>
        <v-card-actions class="ma-0 mt-3 pa-0">
          <v-btn @click="deleteSla" id="sla-dialog-delete-btn" color="error"
            >Yes, delete this service level</v-btn
          >
          <v-btn
            @click="showDeleteDialog = false"
            id="bucket-delete-dialog-cancel-btn"
            color="secondary"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import ServiceLevel from "@/components/service-level/ServiceLevel";
import PageHeader from "@/components/PageHeader.vue";

export default {
  name: "service-level",
  components: { ServiceLevel, PageHeader },
  data: () => {
    return {
      newSlaName: "",
      newSlaBucket: undefined,
      newSlaJeopardyDays: 0,
      newSlaJeopardyHours: 0,
      newSlaJeopardyMinutes: 0,
      newSlaJeopardyTask: 0,
      newSlaBreachDays: 0,
      newSlaBreachHours: 0,
      newSlaBreachMinutes: 0,
      newSlaBreachTask: 0,
      newSlaEnabled: false,
      showDeleteDialog: false,
      slaDeleteIndex: 0,
      addServiceLevelButton: true,
      addServiceLevelForm: false,
    };
  },
  computed: {
    ...mapState({
      slas: (state) =>
        state.currentUser &&
        state.currentUser.account &&
        state.currentUser.account.serviceLevelCriteria
          ? state.currentUser.account.serviceLevelCriteria
          : [],
      caseTypes: (state) =>
        state.caseTypes && Array.isArray(state.caseTypes.all)
          ? state.caseTypes.all
          : [],
    }),
    dayOptions() {
      const days = [];
      for (let i = 0; i < 101; i++) {
        days.push(i);
      }
      return days;
    },
    hourOptions() {
      const hours = [];
      for (let i = 0; i < 25; i++) {
        hours.push(i);
      }
      return hours;
    },
    minuteOptions() {
      const minutes = [];
      for (let i = 0; i < 61; i++) {
        minutes.push(i);
      }
      return minutes;
    },
    buckets() {
      const buckets = [];
      const types =
        this.caseTypes && Array.isArray(this.caseTypes) ? this.caseTypes : [];
      for (const caseType of types) {
        if (!caseType) {
          continue;
        }
        buckets.push({ header: caseType.name });
        const typeBuckets =
          caseType.buckets && Array.isArray(caseType.buckets)
            ? caseType.buckets
            : [];
        buckets.push(...typeBuckets);
      }
      return buckets;
    },
    tasks() {
      let tasks = [];
      const types =
        this.caseTypes && Array.isArray(this.caseTypes) ? this.caseTypes : [];
      if (this.newSlaBucket) {
        for (const caseType of types) {
          if (!caseType || !caseType.buckets || !Array.isArray(caseType.buckets)) {
            continue;
          }
          const bucket = caseType.buckets.find(
            (b) => b && parseInt(b.id, 10) === parseInt(this.newSlaBucket, 10)
          );
          if (bucket) {
            const tasklists =
              caseType.tasklistTemplates &&
              Array.isArray(caseType.tasklistTemplates)
                ? caseType.tasklistTemplates
                : [];
            for (const tasklist of tasklists) {
              if (tasklist && tasklist.tasks && Array.isArray(tasklist.tasks)) {
                tasks = tasks.concat(tasklist.tasks);
              }
            }
          }
        }
      }
      if (tasks.length === 0) {
        return [{ id: -1, description: "Tasks not found!" }];
      }
      return tasks;
    },
  },
  methods: {
    async createSla() {
      const newSla = {
        name: this.newSlaName,
        bucketId: this.newSlaBucket,
        jeopardyDays: this.newSlaJeopardyDays,
        jeopardyHours: this.newSlaJeopardyHours,
        jeopardyMinutes: this.newSlaJeopardyMinutes,
        inJeopardyTaskId: this.newSlaJeopardyTask,
        breachedDays: this.newSlaBreachDays,
        breachedHours: this.newSlaBreachHours,
        breachedMinutes: this.newSlaBreachMinutes,
        inBreachTaskId: this.newSlaBreachTask,
        enabled: this.newSlaEnabled,
      };
      const response = await this.$store.dispatch(
        "createServiceLevelCriteria",
        newSla
      );
      if (!response.error) {
        this.clearCreate();
      }
    },
    clearCreate() {
      this.newSlaName = "";
      this.newSlaBucket = 0;
      this.newSlaJeopardyDays = 0;
      this.newSlaJeopardyHours = 0;
      this.newSlaJeopardyMinutes = 0;
      this.newSlaJeopardyTask = 0;
      this.newSlaBreachDays = 0;
      this.newSlaBreachHours = 0;
      this.newSlaBreachMinutes = 0;
      this.newSlaBreachTask = 0;
      this.newSlaEnabled = false;
      this.addServiceLevelForm = false;
      this.addServiceLevelButton = true;
    },
    updateSla(updates) {
      const indices = [];
      updates.forEach((update) => {
        if (!indices.includes(update.index)) {
          indices.push(update.index);
        }
        this.slas[update.index][update.label] = update.data;
      });
      for (let i = 0; i < indices.length; i++) {
        const index = indices[i];
        const original = this.slas[index];
        if (!original || !original.inJeopardyThreshold || !original.inBreachThreshold) {
          continue;
        }
        const SLA = {
          id: original.id,
          bucketId: original.bucketId,
          name: original.name,
          jeopardyDays: original.inJeopardyThreshold.days,
          jeopardyHours: original.inJeopardyThreshold.hours,
          jeopardyMinutes: original.inJeopardyThreshold.minutes,
          inJeopardyTaskId: original.inJeopardyThreshold.taskId,
          breachedDays: original.inBreachThreshold.days,
          breachedHours: original.inBreachThreshold.hours,
          breachedMinutes: original.inBreachThreshold.minutes,
          inBreachTaskId: original.inBreachThreshold.taskId,
          enabled: original.enabled,
        };
        this.$store.dispatch("updateServiceLevelCriteria", SLA);
      }
    },
    openDelete(i) {
      this.slaDeleteIndex = i;
      this.showDeleteDialog = true;
    },
    deleteSla() {
      const id = this.slas[this.slaDeleteIndex].id;
      this.$store.dispatch("deleteServiceLevelCriteria", id);
      this.showDeleteDialog = false;
    },
  },
};
</script>
